import { ImageModel } from '../models/image/image.model';
import { ImageStylingModel } from '../models/image/image-styling.model';

export const /** @type {?} */ ImageTemplates = {
  defaultTemplate: {
    property: new ImageModel({
      display: true,
      disable: false,
      label: '',
      labelPosition: 'bottom',
      url: 'https://github.com/Cedrusco/cedrus-fusion-lite/blob/master/src/demo/src/assets/images/journal-mountains.jpg?raw=true',
    }),
    style: new ImageStylingModel({
      container: {
        class: 'cf-defaultImageContainer',
      },
      image: {
        class: 'cf-defaultImage',
      },
      label: {
        class: 'cf-defaultImageLabel'
      }
    })
  }
}
